import { LogEvent } from "../../types/Analytics";

export const contactBtnClick : LogEvent = {
    action: "contact_us_click",
  };

  export const subscribeClick : LogEvent = {
    action: "successfully_subscribed",
  };

  export const IntegrateNow : LogEvent = {
    action: "integrate_now",
  };


  export const GetInTouch : LogEvent = {
    action: "get_in_touch",
  };


  export const PartnerNow : LogEvent = {
    action: "partner_now",
  };


  export const IndianGamingReport : LogEvent = {
    action: "india_gaming_report",
  };


  export const PitchNow : LogEvent = {
    action: "pitch_now",
  };



  export const AskQuery : LogEvent = {
    action: "ask_your_query",
  };


  export const DownloadNow : LogEvent = {
    action: "download_now",
  };



  export const MeetUs : LogEvent = {
    action: "meet _us",
  };

  export const StayInTouch : LogEvent = {
    action: "stay_in_touch",
  };

  export const popupBtn : LogEvent = {
    action: "popup_submit_success",
  }

  export const publishBtn : LogEvent = {
    action: "publish_now",
  };


  export const raiseFunds : LogEvent = {
    action: "raised_fun",
  };


  export const schedule_meeting : LogEvent = {
    action: "schedule_meeting",
  };

